<div *ngIf="!isCustomUiChange">
    <h5 mat-dialog-title style="padding:0.2vw; color:black; margin:0 !important">Create Office</h5>
    <mat-divider></mat-divider>
    <div mat-dialog-content style="height: 57vh; width: 100vh;">
        <mat-card class="user-card" style="width: 93%;">
            <mat-card-content>
                <mat-form-field appearance="outline" class="formfield-half" style="width:50% !important">
                    <mat-label>Office ID</mat-label>
                    <input matInput placeholder="Name" [(ngModel)]="officeId" (focusin)="clearMessage()"
                        maxlength="20 ">
                </mat-form-field>
                <mat-form-field appearance="outline" class="formfield-half" style="width:50% !important">
                    <mat-label>Office Name</mat-label>
                    <input matInput placeholder="Name" [(ngModel)]="officeDescription" (focusin)="clearMessage()"
                        maxlength="50">
                </mat-form-field>
                <br>
                <mat-form-field appearance="outline" class="formfield-half">
                    <mat-label>ProgramSponsor</mat-label>
                    <mat-select [(ngModel)]="selectedProgramsponsor">
                        <mat-option *ngFor="let pSponsor of pSponsors" [value]="pSponsor.ProgramSponsorId"
                            style="font-size: 11px;">
                            {{pSponsor.ProgramSponsorId}} - {{pSponsor.ProgramSponsorDescription}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-slide-toggle class="formfield-half" [(ngModel)]="officeActive">Active</mat-slide-toggle>
                <br>
                <br>
                <label style="color: red; font-size: 0.9vw">{{errorMessage}}</label>
            </mat-card-content>
            <mat-card-actions>
                <button mat-raised-button color="primary" (click)="saveOffice();">SAVE</button>
                <button mat-raised-button color="primary" (click)="cancelOffice();">CANCEL</button>
            </mat-card-actions>
        </mat-card>
    </div>
</div>

<!-- new CSS chages apply for FEMD and DOM1 -->
<div *ngIf="isCustomUiChange" class="office-create-container">
    <mat-card class="office-create-card">
        <mat-card-header class="office-card-header">
            <mat-card-title class="office-create-title">Create Office</mat-card-title>

            <button mat-icon-button class="office-create-close" (click)="cancelOffice()">
                <mat-icon>close</mat-icon>
            </button>
        </mat-card-header>

        <mat-divider></mat-divider>

        <mat-card-content class="office-create-form">
            <mat-form-field appearance="outline" class="office-field-half">
                <mat-label>Office ID</mat-label>
                <input matInput [(ngModel)]="officeId" maxlength="20" placeholder="Office ID" (focusin)="clearMessage()">
            </mat-form-field>

            <mat-form-field appearance="outline" class="office-field-half">
                <mat-label>Office Name</mat-label>
                <input matInput [(ngModel)]="officeDescription" maxlength="50" placeholder="Office Name" (focusin)="clearMessage()">
            </mat-form-field>

            <mat-form-field appearance="outline" class="office-field-half">
                <mat-label>Program Sponsor</mat-label>
                <mat-select [(ngModel)]="selectedProgramsponsor">
                    <mat-option *ngFor="let pSponsor of pSponsors" [value]="pSponsor.ProgramSponsorId">
                        {{pSponsor.ProgramSponsorId}} - {{pSponsor.ProgramSponsorDescription}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-slide-toggle [(ngModel)]="officeActive">Active</mat-slide-toggle>

            <label class="office-error-msg">{{ errorMessage }}</label>
        </mat-card-content>

        <mat-card-actions class="office-create-actions">
            <button mat-raised-button color="primary" (click)="saveOffice()">SAVE</button>
            <button mat-raised-button color="primary" (click)="cancelOffice()">CANCEL</button>
        </mat-card-actions>
    </mat-card>
</div>